import React from 'react';
import { Box, Typography } from '@mui/material';

interface FooterProps {
  marginLeft: number;
}

const Footer: React.FC<FooterProps> = ({ marginLeft }) => {
  return (
    <Box
      component="footer"
      sx={{
        width: `calc(100% - ${marginLeft}px)`,
        marginLeft: `${marginLeft}px`,
        padding: 2,
        backgroundColor: '#ECEFF1',
        textAlign: 'center',
        borderTop: '1px solid #CFD8DC',
      }}
    >
      <Typography variant="body2" color="textSecondary">
        &copy; {new Date().getFullYear()} Digital Anarchy
      </Typography>
    </Box>
  );
};

export default Footer;
